import React, { Component } from "react";
import { Card, Button, Header } from "semantic-ui-react";
import PropTypes from "prop-types";
import Strings from "../utilities/StringSelector";
import Constants from "../utilities/Constants";
// import Utils from "../utilities/Utils";
import { connect } from "react-redux";
import { solveProblemAction } from "../../actions/changeActiveItemActions";

// const UtilsInstance = new Utils();

export class ProblemCard extends Component {
  // Intialize this component state
  constructor(props) {
    super(props);
    this.state = {};
  }

  getProblemHeader = () => {
    if (this.props.problem.type === Constants.DUPLICATE_IP_ERROR_TYPE) {
      return (
        <Card.Header style={{ marginBottom: "2px" }}>
          {Strings.DEVICES_WITH_DUPLICATE_IP}
        </Card.Header>
      );
    }
    else if (this.props.problem.type === Constants.PING_ERROR_TYPE) {
      return (
        <Card.Header style={{ marginBottom: "2px" }}>
          {Strings.PING_LIMIT_EXCEEDED}
        </Card.Header>
      );
    }
    else if (this.props.problem.type === Constants.DHCP_ERROR_TYPE) {
      return (
        <Card.Header style={{ marginBottom: "2px" }}>
          {Strings.DHCP_CONFIG_METHOD}
        </Card.Header>
      );
    }
    else if (this.props.problem.type === Constants.PACKET_LOSS_ERROR_TYPE) {
      return (
        <Card.Header style={{ marginBottom: "2px" }}>
          {Strings.PACKET_LOSS_GREATER_ONE_PERCENT}
        </Card.Header>
      );
    }
    else if (this.props.problem.type === Constants.INACTIVE_PORT_ERROR_TYPE) {
      return (
        <Card.Header style={{ marginBottom: "2px" }}>
          {Strings.INACTIVE_PORT}
        </Card.Header>
      );
    }
    else if (this.props.problem.type === Constants.NOT_IN_AUTONEGOTIATION_ERROR_TYPE) {
      return (
        <Card.Header style={{ marginBottom: "2px" }}>
          {Strings.AUTONEGOTIATION_FAILED}
        </Card.Header>
      );
    }
    else if (this.props.problem.type === Constants.NOT_IN_FULL_DUPLEX_ERROR_TYPE) {
      return (
        <Card.Header style={{ marginBottom: "2px" }}>
          {Strings.PORT_NOT_IN_FULL_DUPLEX}
        </Card.Header>
      );
    }
    else if (this.props.problem.type === Constants.INTERFACE_SPEED_ERROR_TYPE) {
      return (
        <Card.Header style={{ marginBottom: "2px" }}>
          {Strings.INTERFACE_SPEED_LESSER_THAN_100}
        </Card.Header>
      );
    }
    else if (this.props.problem.type === Constants.HARDWARE_FAULT_ERROR_TYPE) {
      return (
        <Card.Header style={{ marginBottom: "2px" }}>
          {Strings.PORT_WITH_LOCAL_HARDWARE_FAULT}
        </Card.Header>
      );
    }
    else if (this.props.problem.type === Constants.ADDR_CONFLICT_ERROR_TYPE) {
      return (
        <Card.Header style={{ marginBottom: "2px" }}>
          {Strings.ADDR_CONFLICT_DETECTED}
        </Card.Header>
      );
    }
    // Media Counters
    else if (this.props.problem.type === Constants.MEDIA_COUNTERS_TYPE) {
      return (
        <Card.Header style={{ marginBottom: "2px" }}>
          {Strings.MEDIA_COUNTERS_HEADER}
        </Card.Header>
      );
    }
    // Interface Counters
    else if (this.props.problem.type === Constants.INTERFACE_COUNTERS_TYPE) {
      return (
        <Card.Header style={{ marginBottom: "2px" }}>
          {Strings.INTERFACE_COUNTERS_HEADER}
        </Card.Header>
      );
    }
    else if (this.props.problem.type === Constants.FAULT_ERROR_TYPE) {
      return (
        <Card.Header style={{ marginBottom: "2px" }}>
          {Strings.DEVICE_WITH_FAULT}
        </Card.Header>
      );
    }
    else if (this.props.problem.type === Constants.LOST_IP_ERROR_TYPE) {
      return (
        <Card.Header style={{ marginBottom: "2px" }}>
          {Strings.DEVICE_WITH_LOST_IP}
        </Card.Header>
      );
    }
    else {
      return "";
    }
  }

  formatTime = () => {
    if (this.props.problem.ntp !== null && this.props.problem.ntp === true && this.props.problem.time !== null) {
      let parsedMillis = Date.parse(this.props.problem.time);
      let dateToShow = new Date(parsedMillis);
      return dateToShow.toLocaleString(Strings.DATE_LOCALE);
    }
    else if (this.props.problem.time !== undefined && this.props.problem.time !== null) {
      const eventTimeInMillis = this.props.problem.time * 1000;
      const uptimeInMillis = this.props.startTime * 1000;
      const timeNow = new Date().getTime();
      const time = timeNow - uptimeInMillis + eventTimeInMillis;
      const dateToShow = new Date(time);
      return (dateToShow.toLocaleString(Strings.DATE_LOCALE));
    }
    else {
      return Strings.UNKNOWN;
    }
  }

  getProblemMeta = () => {
    let problemDate = this.formatTime();

    if (this.props.problem.type === Constants.MEDIA_COUNTERS_TYPE
      || this.props.problem.type === Constants.INTERFACE_COUNTERS_TYPE) {
      return (
        <Card.Meta>
          <strong>
            {Strings.INCREMENT_DETECTED_ON}
            {problemDate.toLocaleString(Strings.DATE_LOCALE)}
          </strong>
        </Card.Meta>
      );
    }
    else {
      return (
        <Card.Meta>
          <strong>
            {Strings.DETECTED_ON}
            {problemDate.toLocaleString(Strings.DATE_LOCALE)}
          </strong>
        </Card.Meta>
      );
    }
  }

  getProblemDescription = () => {
    if (this.props.problem.type === Constants.DUPLICATE_IP_ERROR_TYPE) {
      let combinedInfos = [];

      for (let i = 0; i < this.props.problem.macs.length; i++) {
        combinedInfos.push({
          "mac": this.props.problem.macs[i],
          "name": this.props.problem.names[i]
        });
      }

      return (
        <React.Fragment>
          <Card.Description>
            <p><strong>{Strings.DUPLICATE_IP_CARD_DESC}</strong> {this.props.problem.ip}</p>
            <ul>
              {
                combinedInfos.map(info => (
                  <li key={info.mac}>
                    <strong>{Strings.MAC}: </strong> {info.mac.toUpperCase()} /
                    <strong> {Strings.PRODUCT_NAME}:</strong> {info.name}
                  </li>
                ))
              }
            </ul>
          </Card.Description>
        </React.Fragment>
      );
    }
    else if (this.props.problem.type === Constants.PING_ERROR_TYPE) {
      return (
        <React.Fragment>
          <Card.Description>
            <Header as="h4" style={headerStyle}>{Strings.DEVICE}:</Header>
            <p>
              <b>{Strings.PING_LIMIT_DESCRIPTION_1}</b> {this.props.problem.ip} <br />
              <b>{Strings.PING_LIMIT_DESCRIPTION_2}</b> {this.props.problem.mac.toUpperCase()} <br />
              <b>{Strings.PING_LIMIT_DESCRIPTION_3}</b> {this.props.problem.product_name} <br />
              <b>{Strings.PING_LIMIT_DESCRIPTION_4}</b> {this.props.problem.ping.toFixed(2)}{Strings.MILLISECONDS_SUFFIX} <br />
            </p>
          </Card.Description>
        </React.Fragment>
      );
    }
    else if (this.props.problem.type === Constants.DHCP_ERROR_TYPE) {
      return (
        <React.Fragment>
          <Card.Description>
            <Header as="h4" style={headerStyle}>{Strings.DEVICE}:</Header>
            <p>
              <b>{Strings.PING_LIMIT_DESCRIPTION_1}</b> {this.props.problem.ip} <br />
              <b>{Strings.PING_LIMIT_DESCRIPTION_2}</b> {this.props.problem.mac.toUpperCase()} <br />
              <b>{Strings.PING_LIMIT_DESCRIPTION_3}</b> {this.props.problem.product_name} <br />
              <b>{Strings.CONFIG_METHOD}:</b> {this.props.problem.config_method} <br />
            </p>
          </Card.Description>
        </React.Fragment>
      );
    }
    else if (this.props.problem.type === Constants.PACKET_LOSS_ERROR_TYPE) {
      return (
        <React.Fragment>
          <Card.Description>
            <Header as="h4" style={headerStyle}>{Strings.DEVICE}:</Header>
            <p>
              <b>{Strings.PING_LIMIT_DESCRIPTION_1}</b> {this.props.problem.ip} <br />
              <b>{Strings.PING_LIMIT_DESCRIPTION_2}</b> {this.props.problem.mac.toUpperCase()} <br />
              <b>{Strings.PING_LIMIT_DESCRIPTION_3}</b> {this.props.problem.product_name} <br />
              <b>{Strings.PACKET_LOSS_DESCRIPTION}</b> {this.props.problem.lostPacketsPercentage.toFixed(2)}% <br />
            </p>
          </Card.Description>
        </React.Fragment>
      );
    }
    else if (this.props.problem.type === Constants.INACTIVE_PORT_ERROR_TYPE) {
      return (
        <React.Fragment>
          <Card.Description>
            <Header as="h4" style={headerStyle}>{Strings.DEVICE}:</Header>
            <p>
              <b>{Strings.PING_LIMIT_DESCRIPTION_1}</b> {this.props.problem.ip} <br />
              <b>{Strings.PING_LIMIT_DESCRIPTION_2}</b> {this.props.problem.mac.toUpperCase()} <br />
              <b>{Strings.PING_LIMIT_DESCRIPTION_3}</b> {this.props.problem.product_name} <br />
              <b>{Strings.PORT}:</b> {this.props.problem.interface_label} <br />
            </p>
          </Card.Description>
        </React.Fragment>
      );
    }
    else if (this.props.problem.type === Constants.NOT_IN_AUTONEGOTIATION_ERROR_TYPE) {
      return (
        <React.Fragment>
          <Card.Description>
            <Header as="h4" style={headerStyle}>{Strings.DEVICE}:</Header>
            <p>
              <b>{Strings.PING_LIMIT_DESCRIPTION_1}</b> {this.props.problem.ip} <br />
              <b>{Strings.PING_LIMIT_DESCRIPTION_2}</b> {this.props.problem.mac.toUpperCase()} <br />
              <b>{Strings.PING_LIMIT_DESCRIPTION_3}</b> {this.props.problem.product_name} <br />
              <b>{Strings.PORT}:</b> {this.props.problem.interface_label} <br />
              <b>{Strings.NEGOTIATION_STATUS}:</b> {this.props.problem.negotiation_status} <br />
            </p>
          </Card.Description>
        </React.Fragment>
      );
    }
    else if (this.props.problem.type === Constants.NOT_IN_FULL_DUPLEX_ERROR_TYPE) {
      return (
        <React.Fragment>
          <Card.Description>
            <Header as="h4" style={headerStyle}>{Strings.DEVICE}:</Header>
            <p>
              <b>{Strings.PING_LIMIT_DESCRIPTION_1}</b> {this.props.problem.ip} <br />
              <b>{Strings.PING_LIMIT_DESCRIPTION_2}</b> {this.props.problem.mac.toUpperCase()} <br />
              <b>{Strings.PING_LIMIT_DESCRIPTION_3}</b> {this.props.problem.product_name} <br />
              <b>{Strings.PORT}:</b> {this.props.problem.interface_label} <br />
              <b>{Strings.DUPLEX_MODE}:</b> {this.props.problem.duplex} <br />
            </p>
          </Card.Description>
        </React.Fragment>
      );
    }
    else if (this.props.problem.type === Constants.INTERFACE_SPEED_ERROR_TYPE) {
      return (
        <React.Fragment>
          <Card.Description>
            <Header as="h4" style={headerStyle}>{Strings.DEVICE}:</Header>
            <p>
              <b>{Strings.PING_LIMIT_DESCRIPTION_1}</b> {this.props.problem.ip} <br />
              <b>{Strings.PING_LIMIT_DESCRIPTION_2}</b> {this.props.problem.mac.toUpperCase()} <br />
              <b>{Strings.PING_LIMIT_DESCRIPTION_3}</b> {this.props.problem.product_name} <br />
              <b>{Strings.PORT}:</b> {this.props.problem.interface_label} <br />
              <b>{Strings.INTERFACE_SPEED}:</b> {this.props.problem.interface_speed}{Strings.MEGABITS_PER_SECOND_SUFFIX} <br />
            </p>
          </Card.Description>
        </React.Fragment>
      );
    }
    else if (this.props.problem.type === Constants.HARDWARE_FAULT_ERROR_TYPE) {
      return (
        <React.Fragment>
          <Card.Description>
            <Header as="h4" style={headerStyle}>{Strings.DEVICE}:</Header>
            <p>
              <b>{Strings.PING_LIMIT_DESCRIPTION_1}</b> {this.props.problem.ip} <br />
              <b>{Strings.PING_LIMIT_DESCRIPTION_2}</b> {this.props.problem.mac.toUpperCase()} <br />
              <b>{Strings.PING_LIMIT_DESCRIPTION_3}</b> {this.props.problem.product_name} <br />
              <b>{Strings.PORT}:</b> {this.props.problem.interface_label} <br />
            </p>
          </Card.Description>
        </React.Fragment>
      );
    }
    else if (this.props.problem.type === Constants.ADDR_CONFLICT_ERROR_TYPE) {
      return (
        <React.Fragment>
          <Card.Description>
            <Header as="h4" style={headerStyle}>{Strings.DEVICE}:</Header>
            <p>
              <b>{Strings.PING_LIMIT_DESCRIPTION_1}</b> {this.props.problem.ip} <br />
              <b>{Strings.PING_LIMIT_DESCRIPTION_2}</b> {this.props.problem.mac.toUpperCase()} <br />
              <b>{Strings.PING_LIMIT_DESCRIPTION_3}</b> {this.props.problem.product_name} <br />
              <b>{Strings.ACD_STATUS}:</b> {this.props.problem.acd_status} <br />
            </p>
          </Card.Description>
        </React.Fragment>
      );
    }
    // Media Counters Problem
    else if (this.props.problem.type === Constants.MEDIA_COUNTERS_TYPE) {
      let portsString = "";

      for (let port of this.props.problem.ports) {
        portsString += port + ", ";
      }

      portsString = portsString.substring(0, portsString.length - 2);

      return (
        <React.Fragment>
          <Card.Description>
            <Header as="h4" style={headerStyle}>{Strings.DEVICE_HAS_MEDIA_COUNTERS_PROBLEMS}</Header>
            <p>
              <b>{Strings.PING_LIMIT_DESCRIPTION_1}</b> {this.props.problem.ip} <br />
              <b>{Strings.PING_LIMIT_DESCRIPTION_2}</b> {this.props.problem.mac.toUpperCase()} <br />
              <b>{Strings.PORTS}:</b> {portsString} <br />
            </p>
          </Card.Description>
        </React.Fragment>
      );
    }
    // Interface Counters Problem
    else if (this.props.problem.type === Constants.INTERFACE_COUNTERS_TYPE) {
      let portsString = "";

      for (let port of this.props.problem.ports) {
        portsString += port + ", ";
      }

      portsString = portsString.substring(0, portsString.length - 2);

      return (
        <React.Fragment>
          <Card.Description>
            <Header as="h4" style={headerStyle}>{Strings.DEVICE_HAS_INTERFACE_COUNTERS_PROBLEMS}</Header>
            <p>
              <b>{Strings.PING_LIMIT_DESCRIPTION_1}</b> {this.props.problem.ip} <br />
              <b>{Strings.PING_LIMIT_DESCRIPTION_2}</b> {this.props.problem.mac.toUpperCase()} <br />
              <b>{Strings.PORTS}:</b> {portsString} <br />
            </p>
          </Card.Description>
        </React.Fragment>
      );
    }
    else if (this.props.problem.type === Constants.FAULT_ERROR_TYPE) {
      return (
        <React.Fragment>
          <Card.Description>
            <Header as="h4" style={headerStyle}>{Strings.DEVICE}:</Header>
            <p>
              <b>{Strings.IP}:</b> {this.props.problem.ip} <br />
              <b>{Strings.MAC}:</b> {this.props.problem.mac.toUpperCase()} <br />
              <b>{Strings.PRODUCT_NAME}:</b> {this.props.problem.product_name} <br />
            </p>
          </Card.Description>
        </React.Fragment>
      );
    }
    else if (this.props.problem.type === Constants.LOST_IP_ERROR_TYPE) {
      return (
        <React.Fragment>
          <Card.Description>
            <Header as="h4" style={headerStyle}>{Strings.DEVICE}:</Header>
            <p>
              <b>{Strings.IP}:</b> 0.0.0.0 <br />
              <b>{Strings.MAC}:</b> {this.props.problem.mac.toUpperCase()} <br />
              <b>{Strings.MODEL}:</b> {this.props.problem.model} <br />
            </p>
          </Card.Description>
        </React.Fragment>
      );
    }
    else {
      return "";
    }
  }

  getLinkStatus = (link_status) => {
    if (link_status === "Active") {
      return Strings.ACTIVE;
    }
    else if (link_status === "Inactive") {
      return Strings.INACTIVE;
    }
    else {
      return Strings.UNKNOWN;
    }
  }

  getInterfaceSpeed = (interface_speed) => {
    if (interface_speed !== "") {
      return interface_speed + Strings.MEGABITS_PER_SECOND_SUFFIX;
    }
    else {
      return "";
    }
  }

  handleSolvedButtonClick = async () => {
    this.props.onProblemSolve(true, this.props.problem);
  }

  render() {
    return (
      <Card id={this.props.problem.id} fluid raised>
        <Card.Content>
          {this.getProblemHeader()}
          {this.getProblemMeta()}
          {this.getProblemDescription()}
        </Card.Content>
        <Card.Content extra>
          <Button
            basic
            color='green'
            fluid
            onClick={this.handleSolvedButtonClick}>
            {Strings.CHECKED}
          </Button>
        </Card.Content>
      </Card >
    );
  }
}

const mapStateToProps = state => ({
  active: state
});

const mapActionsToProps = {
  onProblemSolve: solveProblemAction
};

ProblemCard.propTypes = {
  nowMillis: PropTypes.number.isRequired,
  startTime: PropTypes.number.isRequired,
  problem: PropTypes.object.isRequired,
  onProblemSolve: PropTypes.func
};

const headerStyle = {
  marginTop: "8px",
  marginBottom: "8px",
};

export default connect(mapStateToProps, mapActionsToProps)(ProblemCard);
